<template>
    <CLoader :pConfigLoad="ConfigLoad">
        <template slot="BodyFormLoad">
            <form role="form" id="FormfacturaCancel" class="form-horizontal" method="post" autocomplete="off" enctype="multipart/form-data">
                    <div class="row">
                        <div class="col-lg-7">
                            <div class="form-group form-row">
                                    <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
                                        <label for="Folio">Folio:</label>
                                        <input type="text" v-model="objFactura.Folio" class="form-control" id="Folio" placeholder="Ingresar Folio" />
                                        <Cvalidation v-if="this.errorvalidacion.Folio" :Mensaje="'*'+errorvalidacion.Folio[0]"/>
                                    </div>
                                </div>
            
                                <div class="form-group form-row">
                                    <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
                                        <label for="Factura">Factura:</label>
                                        <input type="text" v-model="objFactura.Factura" class="form-control" id="Factura" placeholder="Ingresar Factura" />
                                        <Cvalidation v-if="this.errorvalidacion.Factura" :Mensaje="'*'+errorvalidacion.Factura[0]"/>
                                    </div>
                                </div>
            
                                <div class="form-group form-row">
                                    <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
                                        <label for="Cliente">Cliente:</label>
                                        <input type="text" v-model="objFactura.Cliente" class="form-control" id="Cliente" placeholder="Ingresar Cliente" />
                                        <Cvalidation v-if="this.errorvalidacion.Cliente" :Mensaje="'*'+errorvalidacion.Cliente[0]"/>
                                    </div>
                                </div>
            
                                <div class="form-group form-row">
                                    <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
                                        <label for="Observaciones">Observaciones:</label>
                                        <textarea v-model="objFactura.Observaciones" class="form-control" cols="3" rows="3"></textarea>
                                        <Cvalidation v-if="this.errorvalidacion.Observaciones" :Mensaje="'*'+errorvalidacion.Observaciones[0]"/>
                                    </div>
                                </div>
            
                                <div class="form-group form-row">
                                    <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
                                        <label for="MotivoCancel">Motivo de cancelación:</label>
                                        <select v-model="objFactura.MotivoCancel" class="form-control">
                                            <option value="">Seleccionar una opción</option>
                                            <option value="01">01 - Comprobante emitido con errores con relación</option>
                                            <option value="02">02 - Comprobante emitido con errores sin relación</option>
                                            <option value="03">03 - No se llevó a cabo la operación</option>
                                            <option value="04">04 - Operación nominativa relacionada en una factura global</option>                                    </select>
                                        <Cvalidation v-if="this.errorvalidacion.MotivoCancel" :Mensaje="'*'+errorvalidacion.MotivoCancel[0]"/>
                                    </div>
                                </div>
            
                                <div v-show="objFactura.MotivoCancel === '01'" class="form-group form-row">
                                    <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
                                        <label for="FolioSustitucion">Folio de Sustitución:</label>
                                        <input type="text" v-model="objFactura.FolioSustitucion" class="form-control" id="FolioSustitucion" placeholder="Ingresar FolioSustitucion" />
                                        <Cvalidation v-if="this.errorvalidacion.FolioSustitucion" :Mensaje="'*'+errorvalidacion.FolioSustitucion[0]"/>
                                    </div>
                                </div>
                        </div>  
    
                        <div class="col-lg-5 mb-3">
                            <div class="card">
                                <div class="card-header text-white bg-primary">
                                    <h5>Datos de la factura</h5> 
                                </div>
                                <div>
                                    <ul class="list-group list-group-flush">
                                        <li class="list-group-item ">
                                            <label style="font-size:16px;" for=""> Documento : </label> {{ objDatosFactura.Documento }}
                                        </li>
                                        <li class="list-group-item">
                                            <label style="font-size:16px;" for="">Es cancelable : </label> {{ objDatosFactura.EsCancelable }} 
                                        </li>
                                        <li class="list-group-item">
                                            <label style="font-size:16px;" for="">Estado: </label> {{ objDatosFactura.Estado }}
                                        </li>
                                        <li class="list-group-item">
                                            <label style="font-size:16px;" for="">Estatus cancelacion: </label> {{ objDatosFactura.EstatusCancelacion }}
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>  
                    </div>
            </form>
        </template>
    </CLoader>
</template>

<script>
import Configs from '@/helpers/VarConfig.js';

export default {
    name: 'FormFactura',
    props: ['poBtnSave'],
    components:{},
    data() {
        return {
			ConfigLoad:{
                ShowLoader: true,
                ClassLoad: true,
            },
            objFactura: {
				IdFactura: 0,
				IdCotServCal: '',
				EstatusCancel: '',
				TipoCancel: '',
				IdEmpresa: '',
				Folio: '',
				Factura: '',
				Cliente: '',
				Observaciones: '',
				MotivoCancel: '',
				FolioSustitucion: '',
            },
            objDatosFactura:{
                Documento:'',
                EsCancelable:'',
                Estado:'',
                EstatusCancelacion:'',
            },
            errorvalidacion: [],
			Emit: this.poBtnSave.EmitSeccion
        }
    },
    methods :
    {
       	async Guardar()
        {
            // Se valida que motivo de cancelacion y folio de sustitución no esten vacios
            if(!this.Validacion()){
                return false;
            }

            let warn = {...Configs.configEliminar}
            warn.title = '¿Desea cancelar la factura?';

            let confirmacion = false;
            await this.$swal(warn).then((result) => {
                if (result.value) {
                    confirmacion = true;
                } else {
                    confirmacion = false;
                }
            });
            if(confirmacion){
                // Creacion del formdata
                let formData = new FormData();
                formData.set('IdFactura', this.objFactura.IdFactura);
                formData.set('IdCotServCal', this.objFactura.IdCotServCal);
                formData.set('EstatusCancel', this.objFactura.EstatusCancel);
                formData.set('TipoCancel', this.objFactura.TipoCancel);
                formData.set('IdEmpresa', this.objFactura.IdEmpresa);
                formData.set('Folio', this.objFactura.Folio);
                formData.set('Factura', this.objFactura.Factura);
                formData.set('Cliente', this.objFactura.Cliente);
                formData.set('Observaciones', this.objFactura.Observaciones);
                formData.set('MotivoCancel', this.objFactura.MotivoCancel);
                formData.set('FolioSustitucion', this.objFactura.FolioSustitucion);

                this.errorvalidacion = [];
                this.poBtnSave.Toast = 0; 
                this.poBtnSave.DisableBtn = true;
                await this.$http.post(
                    'cartaPorte/postcancel.api',
                    formData,{
                        headers: {
                            'Content-Type': 'multipart/form-data'
                        }
                    }
                ).then((res)=>{
                    this.EjecutaConExito(res);
                }).catch(err=>{   
                    this.EjecutaConError(err);
                });
            }
        },
        Validacion(){
            if(this.objFactura.MotivoCancel === ''){
                this.$toast.error('Seleccione un motivo de cancelación.')
                return false;                
            } else if (this.objFactura.MotivoCancel === '01' && this.objFactura.FolioSustitucion.trim() === ''){
                this.$toast.error('El campo folio de sustitución es un campo obligatorio.')
                return false;
            } else {
                return true;
            }
        },
		EjecutaConExito(res)
        {
            this.poBtnSave.DisableBtn = false;  
            this.poBtnSave.Toast = 1;
            this.bus.$emit('CloseModal_'+this.Emit);
            this.bus.$emit('List_'+this.Emit);
        },
        EjecutaConError(err)
        {
            this.poBtnSave.DisableBtn = false;
            
            if(err.response.data.typemsg == 2){
                this.errorvalidacion = err.response.data.message;
                this.poBtnSave.Toast = 2;
            }
            else{
                this.$toast.error(err.response.data.message);
            }
        },
		Recuperar()
        {
            this.poBtnSave.DisableBtn = true;
            this.$http.get("cartaPorte/recoverycancel.api", {
                    params:{IdFactura:this.objFactura.IdFactura}
                }
            ).then((res) => {
                const resp = res.data.data;
            
                // this.objFactura.Folio = resp.timbrado.UUID;
                // this.objFactura.Factura = resp.factura.folio;
                // this.objFactura.Cliente = resp.razoncliente.RazonSocial;
                // this.objFactura.EstatusCancel = resp.mensaje[0].EsCancelable;
                // this.objFactura.IdFactura = resp.factura.IdFactura;     

                // if (resp.factura.EstatusCancel !== 'Cancelado'){
                //     this.poBtnSave.DisableBtn = true;
                // }
                if(!resp){
                    this.poBtnSave.ShowBtnSave = false;
                }
            }).finally(()=>{
                this.ConfigLoad.ShowLoader = false;
                this.poBtnSave.DisableBtn = false;
            });
        },
        Limpiar()
        {
            this.objFactura = {
				IdFactura: 0,
				IdCotServCal: '',
				EstatusCancel: '',
				TipoCancel: '',
				IdEmpresa: '',
				Folio: '',
				Factura: '',
				Cliente: '',
				Observaciones: '',
				MotivoCancel: '',
				FolioSustitucion: '',
            }
            this.errorvalidacion = [];
        },
    },
    created() {

		this.poBtnSave.Toast = 0;
        this.bus.$off('Recovery_'+this.Emit);
        this.bus.$on('Recovery_'+this.Emit,(Id)=>
        {
            this.ConfigLoad.ShowLoader = true;    
            this.poBtnSave.DisableBtn = false;

            this.bus.$off('Save_'+this.Emit);
            this.bus.$on('Save_'+this.Emit,()=>
            {
                this.Guardar();
            });
            this.Limpiar();
                
            if (Id!=0) 
            {
                this.poBtnSave.ShowBtnSave = true;
                this.objFactura.IdFactura = Id;
                this.Recuperar();
            }
            else
            {
                this.ConfigLoad.ShowLoader = false;
            }
        });
    }
}
</script>